<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<multiselect
						v-model="departmentId"
						:options="departments"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
						:disabled="allDep"
						label="name"
						:placeholder="$t('pricing.department')"
						class="multiselect-pricing"
					/>
					<b-checkbox v-model="allDep" switch>{{$t("Whole_firm")}}</b-checkbox>
				</b-col>
				<b-col>
					<date-picker
						v-model="fromDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.fromDate')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker
						v-model="toDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.toDate')"
						value-type="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col align="center">
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-2 ml-2"/>
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting">
							<b-button class="fa fa-th" variant="dark"/>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ind.label}}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<download-excel v-if="items.length>0" :data="items" :fields="computedJsonToExcel" :disabled="loading" style="cursor: pointer" class="ml-2 btn btn-outline-primary" name="Отчет № 5">
						<b-spinner v-if="loading" small class="mr-2"/><strong>Excel</strong>
					</download-excel>
				</b-col>
			</b-row>
			<hr class="mt-1">
		</div>
		<b-card-body class="marginPage">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 10px">Central Asia Megastar</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{$t("Commodity_report_for_the_period")}}* {{$t("c")}} {{ fromDate ? fromDate : '________' }} {{$t("po")}}
						{{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col>
					<b v-if="allDep" style="font-size: 12px">{{$t("Whole_firm")}}</b>
					<span v-else-if="depNames.length">{{ $t('pricing.department') }}: <b v-for="name in depNames" class="mr-2">{{ name }}</b></span>
					<b v-else>____________</b>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col>
					<b-table :items="items" :fields="computedFields" id="gridContainer" :busy="loading" :responsive="true" small bordered show-empty striped hover foot-clone no-footer-sorting  label-sort-asc="" label-sort-desc="" label-sort-clear="">
						<template #table-busy>
							<div class="text-center my-2">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</div>
						</template>
						<template #cell(index)="data">
							{{ data.index+1 }}
						</template>
						<template #cell(department)="data">
							{{ data.item.department }}
						</template>
						<template #cell(saleInEur)="data">
							{{ data.item.saleInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' ' }) }}
						</template>
						<template #cell(saleInUzs)="data">
							{{ data.item.saleInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
						</template>
						<template #cell(sumInEur)="data">
							{{ data.item.sumInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})}}
						</template>
						<template #cell(sumInUzs)="data">
							{{ data.item.sumInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' ' })}}
						</template>

						<template #foot(index)>
							{{""}}
						</template>
						<template #foot(department)="data">
							<b>{{$t("Itogo")}}</b>
						</template>

						<template #foot(saleInEur)="data">
							<b>{{  sumSaleInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
						</template>
						<template #foot(saleInUzs)="data">
							<b>{{  sumSaleInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
						</template>
						<template #foot(sumInEur)="data">
							<b>{{  sumSumInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
						</template>
						<template #foot(sumInUzs)="data">
							<b>{{sumSumInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
						</template>
					</b-table>
<!--					<b-button v-if="items&&items.length>0" class="float-right mt-1 hidden-print" @click="excelExport1('gridContainer', 'Отчет № 31*')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>-->
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import {BTable, VBTable} from "bootstrap-vue";
import {BOverlay} from 'bootstrapVue2';
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарный отчет за период",
	components: {Multiselect, BTable, VBTable,BOverlay},
	data() {
		return {
			items: [],
			fields: [
				{key: 'index', label: '№', class: 'text-center', visible: true},
				{key: 'department', label: this.$t('pricing.department'), class: 'text-center', visible: true,sortable: true},
				{key: 'saleInEur', label: this.$t('Sale_in_EUR'), class: 'text-center', visible: true,sortable: true},
				{key: 'saleInUzs', label: this.$t('Sale_in_UZS'), class: 'text-center', visible: true,sortable: true},
				{key: 'sumInEur', label: this.$t('Amount_in_EUR'), class: 'text-center', visible: true,sortable: true},
				{key: 'sumInUzs', label: this.$t('Amount_in_UZS'), class: 'text-center', visible: true,sortable: true},
			],
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			allDep: false,
			loading: false,
			depIds: [],
			depNames: []
		};
	},
	methods: {
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			window.print();
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.depIds.length > 0 && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: this.depIds
				}
				ReportService.getReportItems2(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	computed: {
		computedJsonToExcel(){
			let visibleFields = {};
			this.fields.forEach(t =>{
				if (t.visible === true){
					visibleFields[t.label] = t.key;
				}
			})
			return visibleFields;
		},
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},

		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		sumSaleInEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.saleInEur)
					sum = sum + parseFloat(t.saleInEur.toFixed(2))
			})
			return sum;
		},
		sumSaleInUzs() {
			let sum = 0
			this.items.forEach(t => {
				if (t.saleInUzs)
					sum = sum + parseFloat(t.saleInUzs.toFixed(2))
			})
			return sum;
		},
		sumSumInEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.sumInEur)
					sum = sum + parseFloat(t.sumInEur.toFixed(2))
			})
			return sum;
		},
		sumSumInUzs() {
			let sum = 0
			this.items.forEach(t => {
				if (t.sumInUzs) {
					sum = sum + parseFloat(t.sumInUzs.toFixed(2))
				}
			})
			return sum;
		}
	},
	watch: {
		'departmentId': {
			handler(newValue) {
				this.depIds = []
				this.depNames = []
				newValue.forEach(res => {
					this.depIds.push(res.id)
					this.depNames.push(res.name)
				})
			}
		},
		'allDep': {
			handler(res) {
				if (res) {
					this.depIds = []
					this.departments.forEach(r => {
						this.depIds.push(r.id)
					})
				}
			}
		}
	}
}
</script>

<style scoped>

@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.marginPage {
		margin: 0 30px 0 40px;
	}
}
</style>
